import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import classname from 'classnames'; 

import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: '9px',
    opacity: '0.86',
    color: colors.black,
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
  },
  dialogContent: {
    margin: 0,
    padding: 0,
    borderTop: 'solid 1px rgb(58, 58, 58, 0.2)',
  },
}));

const DialogWithTitle = ({
  children,
  onClose,
  open,
  titleComponent,
  fullScreen,
  fullWidth,
  maxWidth,
  className,
  contentClass,
  closeButton = true,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classname(classes.root, className)}
      fullScreen={fullScreen}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      {titleComponent && (
        <MuiDialogTitle disableTypography className={classes.dialogTitle}>
          {titleComponent}
        </MuiDialogTitle>
      )}
      {onClose && closeButton ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}

      <MuiDialogContent className={classname(classes.dialogContent, contentClass)}>{children}</MuiDialogContent>
    </Dialog>
  );
};

DialogWithTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  onClose: PropTypes.func,
  open: PropTypes.bool,
  titleComponent: PropTypes.node,
  fullScreen: PropTypes.bool,
  maxWidth: PropTypes.string,
  className: PropTypes.string,
  contentClass: PropTypes.string,
  closeButton: PropTypes.bool,
};

export default DialogWithTitle;
